import { useLocation } from "react-router-dom";
import { CenterProps, useDisclosure } from "@chakra-ui/react";
import { NavigationHeader } from "@/components/common/navigationHeader/navigationHeader";
import { useContainer } from "./useContainer";
import { DrawerMenu } from "@/components/common/headerMenu";

type Props = {
  onClickWriteStory?: () => void;
} & CenterProps;

export const NavigationHeaderContainer = ({
  onClickWriteStory,
  ...centerProps
}: Props) => {
  const { isApp, tellerUser } = useContainer();
  const location = useLocation();
  const headerMenuDisclosure = useDisclosure();

  if (isApp) {
    return null;
  }

  return (
    <>
      <NavigationHeader
        user={
          tellerUser
            ? {
                name: tellerUser.name?.value ?? "",
                profileImageUrl:
                  tellerUser.thumbnail?.servingUrl?.value ?? undefined,
              }
            : undefined
        }
        selectedPage={getPageType(location.pathname)}
        onClickWriteStory={onClickWriteStory}
        onClickDrawer={headerMenuDisclosure.onOpen}
        {...centerProps}
      />
      <DrawerMenu
        isOpen={headerMenuDisclosure.open}
        onClose={headerMenuDisclosure.onClose}
      />
    </>
  );
};

const getPageType = (pathname: string) => {
  if (pathname === "/") {
    return "home";
  }
  if (pathname === "/contests") {
    return "contest";
  }
  return;
};
